<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Icon"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.8569 16.5725C18.5643 16.5725 18.2718 16.4605 18.0489 16.2377L12 10.1887L5.95107 16.2377C5.50423 16.6845 4.78197 16.6845 4.33513 16.2377C3.88829 15.7908 3.88829 15.0686 4.33513 14.6217L11.192 7.76482C11.6389 7.31798 12.3611 7.31798 12.808 7.76482L19.6649 14.6217C20.1117 15.0686 20.1117 15.7908 19.6649 16.2377C19.442 16.4605 19.1495 16.5725 18.8569 16.5725Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
